import { type FC, useContext, useState } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, FormLabel, Input } from 'base-ui'

import { useGlobalConfigContext } from '../../../global-config'
import { tenantToVatPrefix } from '../../../tenant'
import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'

import './LoginRegistrationRegistrationFormVatInput.css'

export const LoginRegistrationRegistrationFormVatInput: FC = () => {
  const intl = useIntl()
  const { tenant } = useGlobalConfigContext()
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState

  const [isFocused, setIsFocused] = useState(false)

  const isFilled = model.vatNumber && model.vatNumber.trim().length > 0

  const showVatPrefix = isFilled || isFocused

  return (
    <FormControl
      error={!model.validator.isPropertyValid('vatNumber')}
      value={model.vatNumber}
    >
      <FormLabel className="z-10" htmlFor="registerForm-company">
        {`${intl.formatMessage({ id: 'general.label.vatNumber' })}*`}
      </FormLabel>

      <div className="relative">
        <span
          className={`vat-prefix_vat-input pointer-events-none absolute top-1/2 -translate-y-1/2 text-m text-dark-primary-strong transition-opacity duration-200 ${
            showVatPrefix ? 'opacity-100' : 'opacity-0'
          }`}
          id="vat-prefix"
        >
          {tenantToVatPrefix[tenant]}
        </span>
        <Input
          className="pl-12"
          {...registrationFormState.makeInputProps('vatNumber', {
            validateOnBlur: true,
          })}
          id="vatNumber"
          onBlur={() => {
            setIsFocused(false)
            model.validator.validate('vatNumber')
          }}
          onFocus={() => {
            setIsFocused(true)
          }}
          slotProps={{
            input: {
              'data-qa-id': 'professional-account-register-form-vatNumber',
            },
          }}
          type="text"
        />
      </div>

      {model.validator.getFirstErrorFor('vatNumber') && (
        <FormHelperText>
          {model.validator.getFirstErrorFor('vatNumber')}
        </FormHelperText>
      )}
    </FormControl>
  )
}
